import Axios from 'axios';
import Vue from 'vue';
import * as AWS from 'aws-sdk/global';
import S3 from 'aws-sdk/clients/s3';
import { VueEditor, Quill } from "vue2-editor";

export default Vue.extend({
    components: {
        VueEditor
      },
    data: () => ({
        content: "<p>Write Something About Your Company..</p>",
        customToolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["image", "code-block", "video", "link"]
        ],
        company_name : '',
        company_abut : '',
        num_of_employees  : 0,
        employment_type : '',
        location : '',
        category : '',
        opportunity : [],
        fb_url : '',
        linkdin_url : '',
        aboutCompany: ' ',
        aboutCompanyRequired: [
            (v: boolean) => !!v || "About is required",
            //@ts-ignore
           // (v: boolean) => /^[a-zA-Z][\sa-zA-Z]+[0-9]*$/.test(v) || 'First character must be a letter and special character and number not to be allowed.',
            
            //(v: boolean) => /^[a-zA-Z0-9 ]+(([\'\,\&\- ][a-zA-Z0-9 ])?[a-zA-Z0-9]*)*$/.test(v) || "Only alphabets ',' and '&' are allowed in job name",
            // (v: boolean) => /^[a-zA-Z0-9,.&']*$/.test(v) || "Only alphabets, numbers ',' , '.', and '&' are allowed in job title",
            
            (v: boolean) => /^\S/.test(v) || 'Blank space is not allowed at first character',
           //@ts-ignore
            (v: boolean) => v.length <= 100 || 'About must be less than 100 characters',
        ],
        web_url : '',
        url: '../../assets/images/profile.jpg',
        hide: true,
        hidenetwork: true,
        show: false,
        show1: false,
        shownetwork: false,
        shownetwork1: false,
        catergory_arr : [{
            id:1,
            data : 'Large Cap'
        },{
            id:2,
            data : 'Mid cap'
        },{id:3,
            data : 'Startup'
        }
        ],
        employment_arr : [{
            id:1,
            data : 'Permanent'
        },{
            id:2,
            data : 'Part Time'
        }
        ],
        uploadedFileObj : '',
        all_opportunity : [],
        proficiency : '',
        inputValue : false,
        extra_input : [],
        dataLoading:false,
        snackbar : false,
        showMessage : '',
        imageFile : '',
        skipBtn : false,
        websitelinlRequired: [
            (v: boolean) => !!v || "Website Url is required",
            //@ts-ignore
            // (v: boolean) => /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/.test (v) || 'Please enter proper website link'
            (v: boolean) => /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/.test(v) || 'Please enter proper website link'
        ],
        employeenameRequired: [
            (v: boolean) => !!v || "Employer Name is required",
            //@ts-ignore
           // (v: boolean) => /^[a-zA-Z][\sa-zA-Z]+[0-9]*$/.test(v) || 'First character must be a letter and special character and number not to be allowed.',
            
            //(v: boolean) => /^[a-zA-Z0-9 ]+(([\'\,\&\- ][a-zA-Z0-9 ])?[a-zA-Z0-9]*)*$/.test(v) || "Only alphabets ',' and '&' are allowed in job name",
            // (v: boolean) => /^[a-zA-Z0-9,.&']*$/.test(v) || "Only alphabets, numbers ',' , '.', and '&' are allowed in job title",
            
            (v: boolean) => /^\S/.test(v) || 'Blank space is not allowed at first character',
           //@ts-ignore
            (v: boolean) => v.length <= 100 || 'Employee Name must be less than 100 characters',
        ],
        locationRequired: [
            (v: boolean) => !!v || "Location is required",
            //@ts-ignore
           // (v: boolean) => /^[a-zA-Z][\sa-zA-Z]+[0-9]*$/.test(v) || 'First character must be a letter and special character and number not to be allowed.',
            
            //(v: boolean) => /^[a-zA-Z0-9 ]+(([\'\,\&\- ][a-zA-Z0-9 ])?[a-zA-Z0-9]*)*$/.test(v) || "Only alphabets ',' and '&' are allowed in job name",
            // (v: boolean) => /^[a-zA-Z0-9,.&']*$/.test(v) || "Only alphabets, numbers ',' , '.', and '&' are allowed in job title",
            
            (v: boolean) => /^\S/.test(v) || 'Blank space is not allowed at first character',
           //@ts-ignore
            (v: boolean) => v.length <= 100 || 'Location must be less than 100 characters',
        ],
        companysizeRequired: [
            (v: boolean) => !!v || "Company Size is required",
            //@ts-ignore
           // (v: boolean) => /^[a-zA-Z][\sa-zA-Z]+[0-9]*$/.test(v) || 'First character must be a letter and special character and number not to be allowed.',
            
            //(v: boolean) => /^[a-zA-Z0-9 ]+(([\'\,\&\- ][a-zA-Z0-9 ])?[a-zA-Z0-9]*)*$/.test(v) || "Only alphabets ',' and '&' are allowed in job name",
            // (v: boolean) => /^[a-zA-Z0-9,.&']*$/.test(v) || "Only alphabets, numbers ',' , '.', and '&' are allowed in job title",
            
            (v: boolean) => /^\S/.test(v) || 'Blank space is not allowed at first character',
           //@ts-ignore
            (v: boolean) => v.length <= 100 || 'Company Size must be less than 100 characters',
        ],
        // websitelinlRequired:[
        //     (v: boolean) => /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/.test (v) || 'Please enter proper website link'
        // ]
    }),
    created(){
        this.initialize();
        this.profiledata_update();
        this.skipBtn = localStorage.getItem('meassage') == 'fromProfile'?true:false;
     
    },
  
    methods:{
        async initialize() {
            try {
                this.jobLoading = true;
                let token =  localStorage.getItem("jwt");
                if (token) { 
                    const auth = {
                        headers: {authorization: token} 
                    }   
                    let opportunitiesget = await this.$http.get('/profile/fetchOpportunities',auth);
                    if (opportunitiesget.status===200 && opportunitiesget.data.message === "Opportunities found"){
                        this.all_opportunity = opportunitiesget.data.opportunities;
                        this.all_opportunity.push("Others");
                    }
                }
            } catch (error) {
                console.log('Something went wrong, please try again later.');
            }
        },
        async profiledata_update(){
            this.proficiency = [];
            this.dataLoading=true;
            let token =  localStorage.getItem("jwt");
            let userId = localStorage.getItem("userId");
            if (token && userId) { 
                const auth = {
                    headers: {authorization: token} 
                }  
                let recruiter_details = await this.$http.get('/job/fetchRecruiterDetails/'+userId, auth)
                console.log(recruiter_details);
                
                if (recruiter_details.status === 200 && recruiter_details.data.message === "Recruiter found"){
                    this.company_name = recruiter_details.data.recruiter.name!=''?recruiter_details.data.recruiter.name : 'N/A';
                    this.company_abut = recruiter_details.data.recruiter.about; //!='' ? recruiter_details.data.recruiter.about : 'N/A';
                    this.num_of_employees = recruiter_details.data.recruiter.number_of_employees;
                    this.employment_type = recruiter_details.data.recruiter.employment_type;
                    this.location = recruiter_details.data.recruiter.address!=''?recruiter_details.data.recruiter.address:'N/A';
                    this.category = recruiter_details.data.recruiter.category;
                    this.extra_input = recruiter_details.data.recruiter.unlisted_opportunities;

                    recruiter_details.data.recruiter.urls.forEach(element => {
                        if (element.url_name === 'Facebook') {
                            this.fb_url = element.url;
                        } else {
                            this.fb_url == '';
                        }
                        if (element.url_name === 'Linkedin') {
                            this.linkdin_url = element.url;
                        } else {
                            this.linkdin_url == '';
                        }
                        if (element.url_name === 'Company_link'){
                            this.web_url = element.url;
                        }else {
                            this.web_url == '';
                        }
                    });
                    this.proficiency = recruiter_details.data.recruiter.opportunities;
                    this.url = recruiter_details.data.recruiter.profile_image_url; 
                    
                }
                 this.dataLoading=false;
                 console.log("lngrh",this.extra_input.length);
                if(this.extra_input!="") {
                    this.inputValue = true;
                    this.proficiency.push("Others");
                }
            }
        },

        backPage() {
            window.history.back()
        },

        skip(){
            this.$router.replace({ name: 'home' });
        },

        onChange() {
            
            console.log('The new value is: ', this.proficiency);
            if (this.proficiency.includes("Others")) {
                this.inputValue = true;
            }
            else{
                this.inputValue = false;
                this.extra_input = '';
            }
        },

        upload_image(event){ 
            try{
              console.log(event);
              console.log("filename",event.target.files[0]);
              let file = event.target.files[0];
              this.uploadedFileObj = file;
              this.url = URL.createObjectURL(file);
            }
            catch{
            }
          },
       

        async save_update(){
            this.dataLoading=true;
            const bucket = new S3(
            {
                accessKeyId: 'AKIAQW2MZUI4VXB2TF7U',
                // secretAccessKey: '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',
                secretAccessKey: 'uVDVCdLCBp2SpWm0euq7rG9oK/IZJuLMmRI/9Fv4',
                region: 'us-east-1'
            });
                
            let timeStamp = Date.now().toString();
            timeStamp = timeStamp.slice(10, 13);
                    
            console.log(this.uploadedFileObj.name);
            if(this.uploadedFileObj.name != undefined){
                const params = {
                Bucket: 'cracking-it-company-profile',
                Key: timeStamp + '-' + this.uploadedFileObj.name,
                Body: this.uploadedFileObj,
                ACL: 'public-read'
                };
             
           
                //@ts-ignore
                bucket.upload(params, async (err, resultdata) => {
                    if (err) {
                        console.log('There was an error uploading your file: ');
                        return false;
                    }
                    this.imageFile = resultdata.Location;
                    console.log("Loc",this.imageFile);
                    await this.saveData();
                })
            }
            else{
                await this.saveData();
            }
        },
        async saveData(){
            if (this.inputValue) {
                this.proficiency = this.proficiency.filter(item => item !== 'Others')
            } 
           
                let token =  localStorage.getItem("jwt");
                let userId = localStorage.getItem("userId");
                if (token && userId) { 
                    const auth = {
                        headers: {authorization: token} 
                    }  
                    let result_update = await this.$http.post('/profile/updateRecruiterProfile',{
                        // token,
                        name: this.company_name,
                        about: this.company_abut,
                        // .replace(/<\/?[^>]+(>|$)/g, "")
                        category: this.category,
                        employment_type: this.employment_type,
                        opportunities: this.proficiency,
                        unlisted_opportunities : this.extra_input,
                        urls : [
                            {
                                'url_name': 'Facebook',
                                'url': this.fb_url
                            },
                            {
                                'url_name': 'Linkedin',
                                'url': this.linkdin_url
                            },{
                                'url_name': 'Company_link',
                                'url': this.web_url
                            }
                        ],
                        number_of_employees: this.num_of_employees,
                        profile_image_url : this.imageFile==''?this.url:this.imageFile,
                        address: this.location,
                        user_id : userId,
                        city: "N/A",
                        country: "N/A",
                        mobile:"N/A",
                        state:"N/A",
                        pincode : 0,
                    },auth);
                    if (result_update.status===200 && result_update.data.message){
                        this.dataLoading=false;
                        this.snackbar = true;
                        this.showMessage = 'Updated Successfully.'
                        this.$router.back();
                    }
                }
            
        },

        async toggleShow(){
            this.show = !this.show;
        },
        async toggleShow1(){
            this.show1 = !this.show1;
        },
        async toggleShownetwork(){
            this.shownetwork = !this.shownetwork;
        },
        async toggleShow2(){
            this.shownetwork1 = !this.shownetwork1;
        },
    }
})